<template lang="pug">
  div
    Header
    router-view
    Slider
    div.copyright
      span.copyright-text
</template>

<script>
// @ is an alias to /src
// import Waterfall from "@/utils/responsive_waterfall.js";
import Header from "@/components/header";
import Slider from "@/components/slider";

export default {
  data() {
    return {};
  },

  components: {
    Header,
    Slider
  },

  methods: {}
};
</script>

<style>
.copyright {
  position: relative;
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.copyright-text::before {
  /* position: absolute; */
  display: block;
  content: "Copyright \00A9 2020 | Rachel Yu";
  height: 100%;
  width: 100%;
  /* left: 0; */
  /* right: 0; */
  /* bottom: -120px; */
  margin: 0 auto;
  /* width: 100%; */
  font-family: "Arial";
  font-size: 12px;
  color: #CCC;
  /* width: 100%; */
}
</style>
